// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "gsap" + "-" + "d68aa28ddde7a09f" + ".js";
};